import React from 'react';
import PropTypes from 'prop-types';
import RadialRipple from "./RadialRipple";
import _ from 'lodash';
import './IconButton.css';

const ButtonSize = {
    buttonSize32: 'buttonSize32',
    buttonSize36: 'buttonSize36',
    buttonSize40: 'buttonSize40',
    buttonSize44: 'buttonSize44',
    buttonSize48: 'buttonSize48'
};

const IconFontSize = {
    iconFontSize18: 'iconFontSize18',
    iconFontSize24: 'iconFontSize24',
    iconFontSize36: 'iconFontSize36',
    iconFontSize48: 'iconFontSize48'
};

export default class IconButton extends React.Component {

    static propTypes = {
        icon: PropTypes.element.isRequired,
        disabled: PropTypes.bool,
        className: PropTypes.string,
        onMouseDown: PropTypes.func,
        onMouseUp: PropTypes.func,
        onClick: PropTypes.func,
        buttonSize: PropTypes.oneOfType([
            PropTypes.oneOf(Object.keys(ButtonSize)),
            PropTypes.shape({width: PropTypes.number, height: PropTypes.number})
        ]),
        iconFontSize: PropTypes.oneOfType([
            PropTypes.oneOf(Object.keys(IconFontSize)),
            PropTypes.number
        ]),
        buttonProps: PropTypes.object
    };

    static defaultProps = {
        disabled: false,
        buttonSize: ButtonSize.buttonSize48,
        iconFontSize: IconFontSize.iconFontSize24
    };

    static ButtonSize = ButtonSize;

    static IconFontSize = IconFontSize;

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        let classNames = ['materialIconButton'];
        let style = {};
        if (this.props.className) {
            classNames.push(this.props.className);
        }
        if (this.props.disabled) {
            classNames.push('disabled');
        }
        if (this.props.buttonSize) {
            if (_.isString(this.props.buttonSize)) {
                classNames.push(this.props.buttonSize);
            } else if (this.props.buttonSize && _.isNumber(this.props.buttonSize.width) && _.isNumber(this.props.buttonSize.height)) {
                style.width = this.props.buttonSize.width;
                style.height = this.props.buttonSize.height;
            }
        }
        if (this.props.iconFontSize) {
            if (_.isString(this.props.iconFontSize)) {
                classNames.push(this.props.iconFontSize);
            } else if (_.isNumber(this.props.iconFontSize)) {
                style.fontSize = this.props.iconFontSize;
            }
        }
        let props = Object.assign({}, this.props.buttonProps, {
            className: classNames.join(' '),
            disabled: this.props.disabled,
            type: 'button',
            ...(_.size(style) && {style}),
            ...(this.props.onMouseDown && {onMouseDown: this.props.onMouseDown}),
            ...(this.props.onMouseUp && {onClick: this.props.onMouseUp}),
            ...(this.props.onClick && {onClick: this.props.onClick})
        });
        return (
            <button {...props}>
                <RadialRipple disabled={this.props.disabled}/>
                {this.props.icon}
            </button>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/material/IconButton.js